export default "__VITE_ASSET__lMNDG6Ef__"